export default __webpack_public_path__ + "static/media/whatsapp.0f74af52.png";